export default function SubHeader(props) {
  return (
    <section className="subheader">
      <div>
        CS Master @ <div className="hl">UPenn</div>
      </div>
      <div>Who likes games, simulations and tech</div>
      <div>
        Currently exploring <div className="hl">Software Development</div>
      </div>
    </section>
  );
}
